import { DsFormTypeEnum } from '../../enums/ds-forms.enum';
import { DsFormFieldInterface } from '../../interfaces/form-fields/ds-form-field.interface';

export class DsFormField {
  /**
   *
   */
  id?: number;

  /**
   *
   */
  type?: DsFormTypeEnum;

  /**
   *
   */
  label?: string;

  /**
   * The template form field attachments.
   */
  attachments?: string[] = [];

  /**
   * Creates an instance of DsFormField.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsFormFieldInterface) {
    this.id = jsonData.id || null;
    this.type = jsonData.type || this.type;
    this.label = jsonData.label || '';
    this.attachments = jsonData.attachments
      ? // TODO:  Set up the correct type
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        jsonData.attachments.map((attachment: any) => attachment.hash)
      : this.attachments;
  }
}
